var DK = DK || {};
DK.PriceSlider = {
  lastMin: $('input.min-price-range').val(),
  lastMax: $('input.max-price-range').val(),
  debounceDelay: 1000,
  init: function (from, to) {
    DK.PriceSlider.initSliders(from, to);
    DK.PriceSlider.initInputs();
  },
  initSliders: function (from, to) {
    let fromVal = $('input.min-price-range').val();
    let toVal = $('input.max-price-range').val();
    if (from && to) {
      fromVal = from;
      toVal = to;
    }
    $('input.price-slider').each(function () {
      let $slider = $(this);
      let minRange = $slider.data('min');
      let maxRange = $slider.data('max');
      $slider.ionRangeSlider({
        type: 'double',
        grid: true,
        min: minRange,
        max: maxRange,
        from: fromVal,
        to: toVal,
        prefix: '$',
        force_edges: true,
        prettify_enabled: true,
        prettify_separator: ',',
        hide_min_max: true,
        hide_from_to: true,
        onChange: function () {
          DK.PriceSlider.setMinMaxFieldValues($slider.data('ionRangeSlider'));
        },
        onFinish: function () {
          DK.PriceSlider.sendPriceRangeInfo($slider.data('ionRangeSlider'));
        }
      });
      let $ionSlider = $slider.data('ionRangeSlider');
      this.lastMin = $ionSlider.result.min;
      this.lastMax = $ionSlider.result.max;
    });
  },
  initInputs: function () {
    $('input.min-price-range').on('change keyup', function (evt) {
      const $ionSlider = $(this).parents('form.price-range-form').find('input.price-slider').data('ionRangeSlider');
      if (evt.key == 'Enter') {
        DK.PriceSlider.sendPriceRangeInfo($ionSlider);
        return;
      }
      window.setTimeout(() => DK.PriceSlider.updateTimer($ionSlider), DK.PriceSlider.debounceDelay);
      DK.PriceSlider.updateSliderMin($ionSlider);
    });
    $('input.min-price-range').on('blur', evt => {
      let $ionSlider = $(evt.currentTarget).parents('form.price-range-form').find('input.price-slider').data('ionRangeSlider');
      DK.PriceSlider.sendPriceRangeInfo($ionSlider);
    });
    $('input.max-price-range').on('change keyup', function (evt) {
      const $ionSlider = $(this).parents('form.price-range-form').find('input.price-slider').data('ionRangeSlider');
      if (evt.key == 'Enter') {
        DK.PriceSlider.sendPriceRangeInfo($ionSlider);
        return;
      }
      window.setTimeout(() => DK.PriceSlider.updateTimer($ionSlider), DK.PriceSlider.debounceDelay);
      DK.PriceSlider.updateSliderMax($ionSlider);
    });
    $('input.max-price-range').on('blur', evt => {
      let $ionSlider = $(evt.currentTarget).parents('form.price-range-form').find('input.price-slider').data('ionRangeSlider');
      DK.PriceSlider.sendPriceRangeInfo($ionSlider);
    });
  },
  setMinMaxFieldValues: function ($ionSlider) {
    $('input.min-price-range').val($ionSlider.result.from);
    $('input.max-price-range').val($ionSlider.result.to);
  },
  updateSliderMin: function ($ionSlider) {
    const newMin = parseInt($('input.min-price-range').val()),
      // clamp the new min to be >= the range minimum and <= the range maximum
      minValue = Math.max(Math.min(newMin, $ionSlider.result.max), $ionSlider.result.min);
    if (minValue < $ionSlider.result.max) {
      $('input.price-slider').each(function () {
        let $ionSlider = $(this).data('ionRangeSlider');
        $ionSlider.dirtyMin = true;
        $ionSlider.update({
          from: minValue
        });
      });
    }
  },
  updateSliderMax: function ($ionSlider) {
    const newMax = parseInt($('input.max-price-range').val()),
      // clamp the neew max to be >= the range minimum and <= the range maximim
      maxValue = Math.min(Math.max(newMax, $ionSlider.result.min), $ionSlider.result.max);
    if (maxValue > $ionSlider.result.min) {
      $('input.price-slider').each(function () {
        let $ionSlider = $(this).data('ionRangeSlider');
        $ionSlider.dirtyMax = true;
        $ionSlider.update({
          to: maxValue
        });
      });
    }
  },
  updateTimer: function ($ionSlider) {
    if ($ionSlider.dirtyMin || $ionSlider.dirtyMax) {
      DK.PriceSlider.sendPriceRangeInfo($ionSlider);
    }
  },
  sendPriceRangeInfo: function ($ionSlider) {
    let minPrice = parseInt($ionSlider.result.from);
    let maxPrice = parseInt($ionSlider.result.to);
    $ionSlider.dirtyMin = false;
    $ionSlider.dirtyMax = false;
    if (minPrice === maxPrice) {
      if (maxPrice === this.lastMax) {
        minPrice = minPrice - 1;
      } else {
        maxPrice = maxPrice + 1;
      }
    }
    if (minPrice !== this.lastMin || maxPrice !== this.lastMax) {
      const $form = $($ionSlider.input).parents('form.price-range-form');
      let url = new URL(location.href);
      url.searchParams.set('price_range', minPrice + '-' + maxPrice);
      //remove page number parameter
      url.searchParams.delete('page');
      DK.Search.updateListing(url.pathname + url.search, $form.serialize(), $form.offset().top - 400);
      this.lastMin = minPrice;
      this.lastMax = maxPrice;
    }
  },
  destroy: function () {
    $('input.price-slider').each(function () {
      let $ionSlider = $(this).data('ionRangeSlider');
      $ionSlider.destroy();
    });
  }
};
$(function () {
  DK.PriceSlider.init();
});